import React from 'react';

const Header = () => {
  return (
    <header>
      <h2 className="text-gray-700 text-center md:text-left text-6xl font-semibold">
        Recipedia
      </h2>
      <h3 className="text-2xl text-center md:text-left font-semibold">
        for food enthusiasts
      </h3>
    </header>
  );
};

export default Header;
